import React from 'react'
import { Row, Col, Typography, Space } from 'antd'
import { EnvironmentOutlined, PhoneOutlined, MailOutlined, WechatOutlined } from '@ant-design/icons'
import './Contact.scss'

import aboutBanner from '../../assets/images/banner-1.jpg'
const { Title, Text, Paragraph } = Typography

const Contact = () => {
  // 联系信息数据（匹配设计稿）
  const contactList = [
    {
      icon: <EnvironmentOutlined className='contact-icon' />,
      label: 'Address',
      value: 'UNIT135， 1/F.,143 WAI YIP STREET,KWUN TONG HK.'
    },
    {
      icon: <PhoneOutlined className='contact-icon' />,
      label: 'Whats App',
      value: '+85257899890, +85257905149'
    },
    {
      icon: <MailOutlined className='contact-icon' />,
      label: 'E-mail',
      value: 'shawnamosleyvqga714@gmail.com'
    }
  ]

  return (
    <div className='contact-page'>
      <section className='about-banner'>
        <div className='banner-bg' style={{ backgroundImage: `url(${aboutBanner})` }}>
          <div className='banner-overlay'>
            <div className='banner-inner'>
              <Title level={2} className='banner-title'>
                CONTACT US
              </Title>
            </div>
          </div>
        </div>
      </section>
      {/* 1. 标题区域 */}
      <section className='contact-header section'>
        <div className='section-inner'>
          <Title level={2} className='company-title'>
            L AND P TRADE LIMITED
            <span className='title-underline'></span>
          </Title>
          <Paragraph className='contact-subtitle'>
            Welcome to inquire about details and configure a suitable purchasing plan for you
          </Paragraph>
        </div>
      </section>

      {/* 2. 联系信息区域 */}
      <section className='contact-info-section section'>
        <div className='section-inner'>
          <Row gutter={[30, 20]}>
            {contactList.map((item, index) => (
              <Col
                key={index}
                xs={24} // 移动端单列
                sm={12} // 平板两列
                md={8} // 桌面四列
                className='contact-item-col'
              >
                <Space direction='vertical' size='large' className='contact-item'>
                  <Space align='center' className='contact-label-row'>
                    {item.icon}
                    <Text className='contact-label'>{item.label}</Text>
                  </Space>
                  <Text className='contact-value'>{item.value}</Text>
                </Space>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </div>
  )
}

export default Contact
